import { useCallback, useState } from "react";

/**
 * Simple email feedback utility that opens user's email client
 * @param context - Optional context string to help identify which component called this
 */
export async function openEmailFeedback(context?: string): Promise<void> {
	const email = "support@tryhumble.com";
	const subject = encodeURIComponent(
		`Issue Report${context ? ` (${context})` : ""}`,
	);
	const mailtoLink = `mailto:${email}?subject=${subject}`;

	if (typeof window !== "undefined") {
		window.location.href = mailtoLink;
	}
}

/**
 * Hook for managing support modal state
 * Use this in layouts or components where you want to show the support modal
 */
export function useSupportModal(
	defaultType?: "bug" | "feature" | "question" | "other",
) {
	const [isOpen, setIsOpen] = useState(false);
	const [feedbackType, setFeedbackType] = useState<
		"bug" | "feature" | "question" | "other" | undefined
	>(defaultType);

	const openSupportModal = useCallback(
		(type?: "bug" | "feature" | "question" | "other") => {
			setFeedbackType(type || defaultType);
			setIsOpen(true);
		},
		[defaultType],
	);

	const closeSupportModal = useCallback(() => {
		setIsOpen(false);
		setFeedbackType(defaultType);
	}, [defaultType]);

	return {
		isOpen,
		feedbackType,
		openSupportModal,
		closeSupportModal,
	};
}

// For backward compatibility - you can use either approach
export { openEmailFeedback as openFeedback };
